// src/hooks/useDropdownChoices.js

import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { API_URI } from '../constants/appConstants';

const useDropdownChoices = () => {
  const fetchBackgroundChoices = async () => {
    const { data } = await axios.get(
      `${API_URI}/masseuses/?active=true&page=1&page_size=500`
    );

    // Use Set for automatic deduplication
    const backgroundSet = new Set();
    const hairColorSet = new Set();

    // Filter only visible profiles once
    const visibleMasseuses = data.results.filter(
      (masseuse) => masseuse.profile_visible === true
    );

    for (const masseuse of visibleMasseuses) {
      // Process backgrounds
      if (masseuse.background) {
        const tempBackList = masseuse.background.split('/');

        for (const back of tempBackList) {
          if (back.length > 2) {
            const backToInsert = back.replace(',', '').replace('/', '').trim();
            backgroundSet.add(backToInsert);
          }
        }
      }

      // Process hair colors
      if (masseuse.hair_color) {
        const tempHairColorList = masseuse.hair_color.split('/');

        for (const color of tempHairColorList) {
          if (color.length > 2) {
            const hairColorToInsert = color
              .replace(',', '')
              .replace('/', '')
              .trim();
            hairColorSet.add(hairColorToInsert);
          }
        }
      }
    }

    // Convert Sets to sorted arrays
    const backgroundList = Array.from(backgroundSet).sort();
    const hairColorList = Array.from(hairColorSet).sort();

    return { backgrounds: backgroundList, hairColors: hairColorList };
  };

  // Convert to TanStack React Query v5 syntax
  const query = useQuery({
    queryKey: ['backgroundChoices'],
    queryFn: fetchBackgroundChoices,
    gcTime: Infinity, // renamed from cacheTime in v5
    staleTime: Infinity,
  });

  const { data: dropdowns, isLoading: dropdownsLoading, error } = query;

  return [dropdowns, dropdownsLoading, error];
};

export default useDropdownChoices;
